import Switch, { SwitchChangeEventHandler } from 'antd/es/switch';
import Title from 'antd/es/typography/Title';
import React from 'react';

interface UserListGroupButtonProps {
  title: string;
  checked: boolean;
  onChange: SwitchChangeEventHandler;
  loading: boolean;
  disabled: boolean;
}

function UserListGroupButton(props: UserListGroupButtonProps) {
  return (
    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
      <Title level={5}>{props.title}</Title>
      <Switch checked={props.checked} onChange={props.onChange} loading={props.loading} disabled={props.disabled} />
    </div>
  );
}

export default UserListGroupButton;
